"use client";

import { c as _c } from "react/compiler-runtime";
import { OutsideLink } from "@/components/OutsideLink";
import { isLocale, type Locale } from "@/i18n/routing";
import { ClockCircleOutlined, EnvironmentOutlined, LinkOutlined, TagsOutlined } from "@ant-design/icons";
import { Divider, Space, Tag } from "antd";
import { useLocale, useTranslations } from "next-intl";
import React from "react";
import styles from "./ExperienceSection.module.sass";
import { getExperienceData } from "./buildExperienceData";
const LOGO_SIZE = 64;

/** First visible character, safe for surrogate pairs and combining marks. */
function monogramOf(text: string): string {
  const first = Array.from(text.trim())[0];
  return first ? first.toUpperCase() : "?";
}
export interface IPropsExperienceSection {}
export const ExperienceSection: React.FunctionComponent<IPropsExperienceSection> = () => {
  const $ = _c(35);
  const locale = useLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = isLocale(locale) ? locale : "en-US";
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const safeLocale = t0;
  const t = useTranslations("sections");
  const tExperience = useTranslations("experience");
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== safeLocale || $[3] !== t || $[4] !== tExperience) {
    const data = getExperienceData(safeLocale, tExperience);
    t7 = "ExperienceSection";
    t8 = "ExperienceSection.tsx";
    let t10;
    if ($[15] !== t) {
      t10 = t("experience");
      $[15] = t;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    if ($[17] !== t10) {
      t9 = <h2 className={styles.title}>{t10}</h2>;
      $[17] = t10;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    T0 = Space;
    t1 = "vertical";
    t2 = 32;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        width: "100%"
      };
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    t4 = "Space";
    t5 = "ExperienceSection.tsx";
    let t11;
    if ($[20] !== t) {
      t11 = category => <section key={category.category_key}><h3 className={styles.category_name}>{t(category.category_key)}</h3><Space className={styles.list} orientation="vertical" size={32}>{category.items.map(_temp2)}</Space></section>;
      $[20] = t;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    t6 = data.map(t11);
    $[2] = safeLocale;
    $[3] = t;
    $[4] = tExperience;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[22] !== T0 || $[23] !== t1 || $[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
    t10 = <T0 orientation={t1} size={t2} style={t3} data-sentry-element={t4} data-sentry-source-file={t5}>{t6}</T0>;
    $[22] = T0;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t11 = <div data-sentry-component={t7} data-sentry-source-file={t8}>{t9}{t10}</div>;
    $[30] = t10;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
};
function _temp(tag) {
  return <Tag key={tag}>{tag}</Tag>;
}
function _temp2(item) {
  return <article key={item.id} className={styles.item}><div className={styles.item_icon} aria-hidden={true}>{item.icon?.src ? <img src={item.icon.src} alt="" width={LOGO_SIZE} height={LOGO_SIZE} style={{
        width: LOGO_SIZE,
        height: "auto"
      }} loading="lazy" decoding="async" /> : <span className={styles.item_monogram}>{monogramOf(item.organization)}</span>}</div><div className={styles.item_info}><div className={styles.item_info_organization}>{item.organization}{item.legal_entity && <span className={styles.item_info_legal_entity}>{item.legal_entity}</span>}</div><div className={styles.item_info_name}><Space separator={<Divider orientation="vertical" />} size={[0, 4]} wrap={true}><div>{item.name}</div>{item.department && <div>{item.department_url ? <OutsideLink href={item.department_url} style={{
              color: "unset"
            }}>{item.department}</OutsideLink> : item.department}</div>}</Space></div><div className={styles.item_info_organization_url}><LinkOutlined aria-hidden={true} />{" "}<OutsideLink href={item.organization_url} /></div><div className={styles.item_info_meta}><Space separator={<Divider orientation="vertical" />} size={[0, 4]} wrap={true}><div><ClockCircleOutlined aria-hidden={true} />{" "}{item.time_range.start} ~ {item.time_range.end}</div><div><EnvironmentOutlined aria-hidden={true} />{" "}{item.location}</div></Space></div>{item.note && <div className={styles.item_info_note}>{item.note}</div>}{(item.tags?.length ?? 0) > 0 && <Space className={styles.item_info_tags} wrap={true}><TagsOutlined aria-hidden={true} />{" "}{item.tags.map(_temp)}</Space>}</div></article>;
}